// extracted by mini-css-extract-plugin
export default {"hr":"Divider-module_hr_c1eaee"};